import { observable, configure, action, runInAction } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class CuratedContentStore extends LocalModel {
    constructor() {
        super('curatedContent', {
            namePlural: 'curatedContents',
            sort: '-createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/curatedcontent/admin',
                    params: {
                        limit: 50,
                        sort: '-createdDate',
                        status: 'pending',
                    },
                },
                load: {
                    url: '/api/curatedcontent/admin',
                    params: {},
                },
                save: {
                    url: '/api/curatedcontent/admin',
                    params: {},
                },
                delete: {
                    url: '/api/curatedcontent/admin',
                    params: {},
                },
            },
        });
    }

    @observable curatedContents = [];
    @observable pendingCount = 0;

    @action
    loadPendingCount = async () => {
        try {
            const response = await util.fetchApi('/api/curatedcontent/admin?status=pending&limit=1');
            runInAction(() => {
                this.pendingCount = response?.pagination?.total || 0;
            });
        } catch (e) {
            // Silently fail - user may not have access
        }
    }
}

const store = new CuratedContentStore();
export default store;
